export default __webpack_public_path__ + "static/media/fb-1.15bd01c5.svg";